import type { Hooks } from "react-table";

/* eslint:disable no-implicit-any, no-nested-ternary, @typescript-eslint/ban-types */

// Entire file is a copy from react-table with changed flex prop calculation

const getTableProps = (props, { instance }) => [
    props,
    {
        style: {
            minWidth: `${instance.totalColumnsMinWidth}px`,
        },
    },
];

const getRowStyles = (props, { instance }) => [
    props,
    {
        style: {
            display: "flex",
            flex: "1 0 auto",
            minWidth: `${instance.totalColumnsMinWidth}px`,
        },
    },
];

const getHeaderProps = (props, { column }) => {
    const maxWidth: number = column.totalMaxWidth;
    const minWidth: number = column.totalMinWidth;
    const width: number = column.totalWidth;
    const flexGrow = width === maxWidth ? 0 : width;
    const flexShrink = width === minWidth ? 0 : 1;

    return [
        props,
        {
            style: {
                boxSizing: "border-box",
                flexGrow,
                flexShrink,
                width,
                minWidth,
                maxWidth,
            },
        },
    ];
};

const getCellProps = (props, { cell }) => {
    const maxWidth: number = cell.column.totalMaxWidth;
    const minWidth: number = cell.column.totalMinWidth;
    const width: number = cell.column.totalWidth;
    const flexGrow = width === maxWidth ? 0 : width;
    const flexShrink = width === minWidth ? 0 : 1;

    return [
        props,
        {
            style: {
                boxSizing: "border-box",
                flexGrow,
                flexShrink,
                width,
                minWidth,
                maxWidth,
            },
        },
    ];
};

const getFooterProps = (props, { column }) => {
    const maxWidth: number = column.totalMaxWidth;
    const minWidth: number = column.totalMinWidth;
    const width: number = column.totalWidth;
    const flexGrow = width === maxWidth ? 0 : width;
    const flexShrink = width === minWidth ? 0 : 1;

    return [
        props,
        {
            style: {
                boxSizing: "border-box",
                flex: `${flexGrow} ${flexShrink} auto`,
                width,
                minWidth,
                maxWidth,
            },
        },
    ];
};

// eslint-disable-next-line
export function useFixedFlexLayout<D extends object = {}>(hooks: Hooks<D>) {
    hooks.getTableProps.push(getTableProps);
    hooks.getRowProps.push(getRowStyles);
    hooks.getHeaderGroupProps.push(getRowStyles);
    hooks.getFooterGroupProps.push(getRowStyles);
    hooks.getHeaderProps.push(getHeaderProps);
    hooks.getCellProps.push(getCellProps);
    hooks.getFooterProps.push(getFooterProps);
}

useFixedFlexLayout.pluginName = "useFlexLayout";

/* eslint:enable no-implicit-any, no-nested-ternary, @typescript-eslint/ban-types */
